import { ProductWithCalculations } from '../shared/types/inventory';

interface MetricsPanelProps {
  product: ProductWithCalculations;
  leadTime: number;
  targetCoverage: number;
}

export const MetricsPanel = ({ product, leadTime, targetCoverage }: MetricsPanelProps) => {
  const metrics = [
    {
      label: 'Estoque Atual',
      value: product.estoqueAtual.toFixed(0),
      unit: 'un',
      color: 'text-slate-900',
      bgColor: 'bg-slate-50',
    },
    {
      label: 'CMD',
      value: product.cmd.toFixed(2),
      unit: 'un/dia',
      color: 'text-blue-700',
      bgColor: 'bg-blue-50',
    },
    {
      label: 'ROP',
      value: product.rop.toFixed(0),
      unit: 'un',
      color: 'text-amber-700',
      bgColor: 'bg-amber-50',
    },
    {
      label: 'Estoque Alvo',
      value: product.estoqueAlvo.toFixed(0),
      unit: 'un',
      color: 'text-emerald-700',
      bgColor: 'bg-emerald-50',
    },
    {
      label: 'Estoque de Segurança',
      value: product.ss.toFixed(0),
      unit: 'un',
      color: 'text-slate-700',
      bgColor: 'bg-slate-50',
    },
    {
      label: 'Cobertura Atual',
      value: product.cobertura.toFixed(1),
      unit: 'dias',
      color: 'text-violet-700',
      bgColor: 'bg-violet-50',
    },
  ];

  return (
    <div className="space-y-4">
      <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-6 text-white shadow-lg">
        <div className="text-sm font-medium opacity-90 mb-1">Pedido Sugerido</div>
        <div className="text-4xl font-bold tracking-tight">{product.pedidoSugerido.toFixed(0)}</div>
        <div className="text-sm opacity-80 mt-1">unidades</div>
        <div className="text-xs opacity-75 mt-3 pt-3 border-t border-white/20">
          = Estoque Alvo - Estoque Atual
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {metrics.map((metric) => (
          <div
            key={metric.label}
            className={`${metric.bgColor} rounded-xl p-4 border border-slate-200/50`}
          >
            <div className="text-xs font-medium text-slate-600 mb-1">{metric.label}</div>
            <div className="flex items-baseline gap-1">
              <span className={`text-2xl font-bold ${metric.color}`}>{metric.value}</span>
              <span className="text-xs text-slate-500">{metric.unit}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
        <div className="text-xs font-semibold text-slate-700 mb-3">Configurações</div>
        <div className="space-y-2 text-xs text-slate-600">
          <div className="flex justify-between">
            <span>Lead Time (LT):</span>
            <span className="font-semibold text-slate-900">{leadTime} dias</span>
          </div>
          <div className="flex justify-between">
            <span>Cobertura Alvo:</span>
            <span className="font-semibold text-slate-900">{targetCoverage} dias</span>
          </div>
          <div className="flex justify-between">
            <span>Vendas no Período:</span>
            <span className="font-semibold text-slate-900">{product.vendasPeriodo} un</span>
          </div>
        </div>
      </div>
    </div>
  );
};
